import { request } from '@/common/ajax/request';
import { Tc } from '@/providers/tc';

export class GoogleAcm extends Tc {
  constructor(options) {
    super(options.categories, options.includedVendors);
    this.vendorList = {};
    this.vendorListBaseUrl = options.baseUrl || 'https://cdn.trustcommander.net/iab-v2';
    for (const [vendorId, vendor] of Object.entries(this.vendorsById)) {
      const publicId = vendorId.split('_')[1];
      vendor.id = publicId;
    }
  }

  async initConsents(consentReducerFn = () => false) {
    await this.getVendorList();
    if (!this.vendorList) {
      return;
    }
    for (const vendor of Object.values(this.vendorsById)) {
      const acmVendor = this.vendorList.providers[vendor.id];
      if (acmVendor) {
        vendor.label = acmVendor.name;
        vendor.policyUrl = acmVendor.policyUrl;
        vendor.domains = acmVendor.domains;
      }
    }
    super.initConsents(consentReducerFn);
  }

  async getVendorList() {
    try {
      this.vendorList = await request.getJson(`${this.vendorListBaseUrl}/` + `google-atp-list.json`);

      return this.vendorList;
    } catch (e) {
      console.error('Google ACM Down', e);
    }
  }
}
